<template>
	<div class="row" >
		<!--<div class="modal-header dark-green">
			<a type="button" style="line-height:0;color:#fff;opacity:1;" class="close" @click="closeModal()" data-dismiss="modal">&times;</a>
			<h4 class="white-font row-table-font-margins" style='font-size:20px; font-family: inherit; font-weight: 400; text-align:center; margin-top:-11px'>Payment to Supplier</h4>
		</div>-->
		
		<div class="col-md-12 modal-body-expense">
			<div class="row" style="padding:5px">

                <div class="col-md-12">

                    <div class="alert alert-danger" v-if="errors.length">
                        <strong>Whoops!</strong> There were some problems with your input.<br><br>
                        <ul>
                            <li v-for="error in errors" :key="error">{{ error }}</li>
                        </ul>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="text-left section-title" style="padding: 5px;">
                                <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                                    Pay Now
                                </span>
                            </div>
                        </div>

                    </div>
                    <div class="col-xs-6 col-sm-6 col-md-6">
                        <div class="form-group">
                            <label>Principal:</label>
                            <select class="form-control" v-model="creditorId" v-on:change="onChange">
                                <option v-for="supplier in suppliers" :key="supplier" :value="supplier.id">
                                    {{ supplier.name }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col-md-12" style="margin-bottom:10px;padding:10px;">
                        <table class="table table-condensed" style="border:0;box-shadow:none">
                            <thead>
                                <tr>
                                    <th style="width: 10%;" class="no-border text-center col-md-1">Invoice No</th>
                                    <th style="width: 15%;" class="no-border text-center col-md-2">Expense Type</th>
                                    <th style="width: 10%;" class="no-border text-center col-md-1">Amount of Exp.</th>
                                    <th style="width: 10%;" class="no-border text-center col-md-1">Amount Paid</th>
                                    <th style="width: 10%;" class="no-border text-center col-md-1">Payment</th>
                                    <th style="width: 10%;" class="no-border text-center col-md-1">Remaining</th>
                                    <th style="width: 10%;" class="no-border text-center col-md-1">Reference</th>
                                    <th style="width: 10%;" class="no-border text-center col-md-1">Bank</th>
                                    <th style="width: 10%;" class="no-border text-center col-md-2">Payment Type</th>
                                    <th style="width: 5%;" class="no-border text-center col-md-1">Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="payment in expensePayments" :key="payment">
                                    <td>
                                        <input class="form-control text-right" v-model="payment.invoiceNo" readOnly />
                                    </td>
                                    <td>
                                        <select id="expense-type-id" class="form-control" disabled v-model="payment.expenseTypeId">
                                            <option v-for="expenseType in expenseTypes" :key="expenseType" :value="expenseType.id">
                                                {{ expenseType.name }}
                                            </option>
                                        </select>
                                    </td>
                                    <td>
                                        <input class="form-control text-right" v-model="payment.amountOfExpense" readOnly number data-type="currency" />
                                    </td>
                                    <td>
                                        <input class="form-control text-right" v-model="payment.amountPaid" readOnly number data-type="currency" />
                                    </td>
                                    <td>
                                        <input class="form-control text-right" v-model="payment.payment" @focus="$event.target.select()" number data-type="currency" />
                                    </td>
                                    <td>
                                        <input class="form-control text-right" :value="payment.amountOfExpense - payment.amountPaid- (payment.payment == undefined ? 0 :  payment.payment)" number readonly data-type="currency" />
                                        <input type="hidden" number />
                                    </td>
                                    <td>
                                        <input class="form-control text-right" v-model="payment.reference" />
                                    </td>
                                    <td>
                                        <input class="form-control text-right" v-model="payment.bank" />
                                    </td>
                                    <td>
                                        <select id="payment-type" class="form-control" v-model="payment.paymentType">
                                            <option :value="1">
                                                Cash
                                            </option>
                                            <option :value="2">
                                                Cheque
                                            </option>
                                            <option :value="3">
                                                Bank Order
                                            </option>
                                        </select>
                                    </td>
                                    <td style="width: 5%;">
                                        <date-picker style="border:grey solid 1px" :format="customFormatter" v-model="payment.paidDate" />
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                    </td>
                                    <td class="text-right">
                                        <strong>Totals</strong>
                                    </td>
                                    <td class="text-right">
                                        <strong>{{ $filters.toCurrency(totalAmountOfExpense) }}</strong>
                                    </td>
                                    <td class="text-right">
                                        <strong>{{ $filters.toCurrency(totalAmountPayment) }}</strong>
                                    </td>
                                    <td class="text-right">
                                        <strong>{{ $filters.toCurrency(totalAmountOfPayment) }}</strong>
                                    </td>
                                    <td class="text-right">
                                        <strong>{{ $filters.toCurrency(totalAmountRemaining) }}</strong>
                                    </td>
                                    <td>
                                    </td>
                                    <td>
                                    </td>
                                    <td>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-12 text-center">
                        <div class="text-center">
                            <button type="submit" @click="save()" class="btn btn-submit" style="margin: 15px;">
                                Submit
                            </button>
                            <button @click="closeModal()" class="btn btn-cancel">Cancel</button>
                        </div>
                    </div>
                </div>
			</div>
		</div>
	</div>
</template>
<script>
import { format } from "date-fns";
export default {
  props: ["buildingId", "monthProp"],
  data: function () {
    return {
      expensePayments: {},
      expenseTypes: {},
      suppliers: {},
      building: {},
      building_id: 0,
      month: 0,
      date: "2016-10-16",
      errors: [],
    };
  },

  mounted() {
    this.building_id = this.buildingId;
    // this.creditorId = this.creditorId;
    this.month = this.monthProp;
    this.fetchProperty();
  },

  methods: {
    fetchProperty: async function () {
      var request = "/expensepayments/providers";
      // if(this.route=="home")
      //   request = '/home/statment/get/';
      request = request + "?id=" + this.buildingId;
      this.$http
        .get(request, {
          id: this.buildingId,
        })
        .then(({ data }) => {
          this.mute = false;
          //this.contacts = data.contacts;
          this.mute = false;
          // let myObjStr = JSON.stringify(data.expenseFees);
            this.expensePayments = data.expensePayments;
            for (var i = 0; i < this.expensePayments.length; i++)
                this.expensePayments[i].payment = undefined
          this.suppliers = data.suppliers;
          this.expenseTypes = data.expenseTypes;
        });
    },
    customFormatter(date) {
      //alert(moment(date).format('dd/MM/YYYY'));
      //return date | moment("dddd, MMMM Do YYYY")
      return format(date, "dd/MM/yyyy");
    },

    onChange: async function () {
      try {
        var request = "/expensepayments/provider";
        // if(this.route=="home")
        //   request = '/home/statment/get/';
        request =
          request + "?id=" + this.buildingId + "&creditorId=" + this.creditorId;
        this.$http
          .get(request, {
            id: this.buildingId,
          })
          .then(({ data }) => {
            this.mute = false;
            //this.contacts = data.contacts;
            this.mute = false;
            // let myObjStr = JSON.stringify(data.expenseFees);
              this.expensePayments = data.expensePayments;
              for (var i = 0; i < this.expensePayments.length; i++)
                  this.expensePayments[i].payment = undefined
            console.log(this.creditorId);
            /*  this.mute = true;
                                            const response = await axios.get('/admin/expensespayments/getbycreditor/'+this.building_id+'/'+this.creditor_id);
                                            this.mute = false;
                                            this.expense_types = response.data.expense_types;
                                            this.expensePayments = response.data.expensePayments;*/
          });
      } catch (error) {
        alert(error);
      }
    },

    addRow: function (index) {
      try {
        this.expensePayments.splice(index + 1, 0, {});
      } catch (e) {
        alert(e);
      }
    },
    removeRow: function (index) {
      this.expensePayments.splice(index, 1);
    },
    closeModal: function () {
        this.$modal.hide("control-panel-add-form");
    },
    checkForm: function (e) {
      this.errors = [];

      if (!this.creditorId) {
        this.errors.push("Please select suppliers.");
      }

      for (var i = 0; i < this.expensePayments.length; i++) {
        if (
          this.expensePayments[i].payment > 0 &&
          !this.expensePayments[i].paidDate
        ) {
          this.errors.push("Paid date is required.");
        }
      }

      if (this.errors.length == 0) return;

      e.preventDefault();
    },
    save() {
      this.checkForm();
      this.$http
        .post("/expensepayments", {
          buildingId: this.buildingId,
          expensePayments: this.expensePayments,
        })
        .then(
          () => {
            this.closeModal();
            location.reload();
            this.$router.push({
              name: "controlpanel",
              params: { buildingId: this.buildingId },
            });
          },
          () => {
            alert("error");
            //  this.infoError = true
            //  this.loader = false
            //   this.password = ''
          }
        );
    },
  },

  computed: {
    totalAmountOfExpense() {
      var amount = 0;
      for (var i = 0; i < this.expensePayments.length; i++) {
        amount += this.expensePayments[i].amountOfExpense;
      }
      return parseFloat(amount)  ;
    },
    totalAmountPayment() {
      var amount = 0;
      for (var i = 0; i < this.expensePayments.length; i++) {
        amount += this.expensePayments[i].amountPaid;
      }

      return parseFloat(amount) ;
    },
    totalAmountOfPayment() {
      var amount = 0;
      for (var i = 0; i < this.expensePayments.length; i++) {
          amount += parseFloat(this.expensePayments[i].payment == undefined ? 0 : this.expensePayments[i].payment);
      }

      return amount  ;
    },
    totalAmountRemaining() {
      var amount = 0;
      for (var i = 0; i < this.expensePayments.length; i++) {
        amount +=
          this.expensePayments[i].amountOfExpense -
          this.expensePayments[i].amountPaid -
        (this.expensePayments[i].payment == undefined ? 0 : this.expensePayments[i].payment);
      }
      return parseFloat(amount)  ;
    },
  },
};
</script>